module.exports = __webpack_public_path__ + "static/media/img_ai_project_man.ef08d667.jpg";